import React from 'react';

const PlayMediaIcon = ({
  fillColorCircle = '#FFDC0D',
  fillColorArrow = '#ffffff',
  size = '68',
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox={`-2 -2 69 69`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M65 32.5C65 50.4493 50.4493 65 32.5 65C14.5507 65 0 50.4493 0 32.5C0 14.5507 14.5507 0 32.5 0C50.4493 0 65 14.5507 65 32.5Z"
        fill={fillColorCircle}
        stroke={fillColorArrow}
        strokeWidth={3}
      />
      <path d="M53 32L21.5 50.1865L21.5 13.8135L53 32Z" fill={fillColorArrow} />
    </svg>
  );
};

export default PlayMediaIcon;
